import { useCallback } from 'react';
import { useLocation } from 'wouter';

type UseLocationWithGoBackReturnType = [
  string,
  <S>(
    to: string | URL,
    options?: {
      replace?: boolean;
      state?: S;
    },
  ) => void,
  <S>(options?: { replace?: boolean; state?: S }) => void,
];
export function useLocationWithGoBack(): UseLocationWithGoBackReturnType {
  const [location, setLocation] = useLocation();
  const goBack = useCallback<UseLocationWithGoBackReturnType[2]>(
    (options) => {
      if (history.length > 1) {
        history.go(-1);
        if (options?.replace) {
          setTimeout(() => {
            history.replaceState(null, '', document.referrer || '/');
          }, 0);
        }
      } else {
        setLocation('/', options);
      }
    },
    [setLocation],
  );
  return [location, setLocation, goBack];
}
